module.exports = __webpack_public_path__ + "img/guias_lineales.96b300cb.jpg";